import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BotStatus } from "../../../../shared/_types/bot.type";
import { SubscriptionStatus } from "../../../../shared/_types/subscription-status.type";
import { CommandResult } from "../../../../shared/_types/command-result.type";

@Injectable({
    providedIn: "root",
})
export class UsersService {
    constructor(private http: HttpClient) {}

    list(request: ListUsersRequest): Observable<ListUsersResponse> {
        return this.http.post<ListUsersResponse>("/users", request);
    }

    get(userId: string): Observable<UserFullInfo> {
        return this.http.get<UserFullInfo>(`/users/${userId}`);
    }

    loginAs(userId: string): Observable<UserTokenResponse> {
        return this.http.get<UserTokenResponse>(`/users/${userId}/login-as`);
    }

    getSubscription(userId: string | null): Observable<any> {
        return this.http.get<any>(`/users/${userId}/subscription`);
    }

    updateSubscription(userId: string, subscription: Subscription): Observable<CommandResult> {
        return this.http.put<CommandResult>(`/users/${userId}/subscription`, subscription);
    }

    delete(userId: string): Observable<CommandResult> {
        return this.http.delete<CommandResult>(`/users/${userId}`);
    }

    reloadBotData(userId: string, botId: string): Observable<CommandResult> {
        return this.http.post<CommandResult>(`/users/${userId}/bots/${botId}/reload-data`, {});
    }

    runBot(userId: string, botId: string): Observable<CommandResult> {
        return this.http.post<CommandResult>(`/users/${userId}/bots/${botId}/run-now`, {});
    }
}

export type Subscription = {
    id: string;
    startDate: Date | null;
    endDate: Date | null;
    userId: string;
    status: SubscriptionStatus;
    pricingPackages: SubscriptionPricingPackage[];
};

export type SubscriptionPricingPackage = {
    id?: string;
    subscriptionId: string;
    pricingPackageId: string;
    expirationDate: Date | null;
    isMain: boolean;
};

export type UserTokenResponse = {
    token: string;
};

export type ListUsersRequest = {
    page: number;
    itemsPerPage: number;
    keyword?: string | null | undefined;
    sortOrder?: UsersSortOrder | null | undefined;
};

export enum UsersSortOrder {
    Email = 0,
    EmailDesc = 1,
    RegistrationDate = 2,
    RegistrationDateDesc = 3,
    BrokerAccountsCount = 4,
    BrokerAccountsCountDesc = 5,
    BotsCount = 6,
    BotsCountDesc = 7,
}

export type ListUsersResponse = {
    total: number;
    users: UserListInfo[];
};

export type User = {
    id: string;
    email: string;
    userName: string;
    firstName: string;
    lastName: string;
};

export type UserListInfo = User & {
    brokerAccountsCount: number;
    botsCount: number;
    createdAt: Date;
};

export type UserFullInfo = User & {
    registrationDate: Date;
    roles: string[];
    brokerAccounts: BrokerAccount[];
};

export type BrokerAccount = {
    id: string;
    externalId: string;
    providerType: number;
    accountType: number;
    displayName: string;
    isActive: boolean;
    bots: Bot[];
};

export type Bot = {
    id: string;
    name: string;
    status: BotStatus;
};
